import React from 'react';

function Mauritania(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124051)">
        <mask
          id="mask0_800_124051"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124051)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#1C7B4D"
          />
          <mask
            id="mask1_800_124051"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124051)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V6H36V0H0Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 18V24H36V18H0Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.2723 14.3785C24.1057 14.4073 25.7486 10.0651 25.7486 10.0651C25.4182 13.7799 23.1067 16.2991 18.2723 16.2991C13.4378 16.2991 11.6626 13.0359 10.7959 9.78075C10.7959 9.78075 12.4388 14.3498 18.2723 14.3785Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.8418 9.81367L20.2206 11.7772L18.2369 10.8501L16.2531 11.7772L16.6319 9.81367L15.027 8.27986L17.245 8.27986L18.2369 6.35014L19.2287 8.27986L21.4467 8.27986L19.8418 9.81367Z"
              fill="#FECA00"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124051">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Mauritania;
